import classNames from "classnames";
import React from "react";
import styles from "./defaultAgentAvatar.css";

interface Props {
  widgetStyle?: boolean;
}

export class DefaultAgentAvatar extends React.Component<Props, {}> {
  container?: HTMLElement;
  icon?: HTMLElement;

  updateSize() {
    if (this.container && this.icon) {
      (this.icon as HTMLElement).style.fontSize =
        (this.container as HTMLElement).offsetHeight + "px";
    }
  }

  componentDidMount() {
    this.updateSize();
  }

  componentDidUpdate() {
    this.updateSize();
  }

  render() {
    return (
      <div
        className={classNames(styles.avatar, { [styles.dashboard]: !this.props.widgetStyle })}
        ref={(el) => (this.container = el || undefined)}
      >
        <i className="icon-default-avatar" ref={(el) => (this.icon = el || undefined)} />
      </div>
    );
  }
}
